<template>
    <Fragment>
        <nav-menu />
        <div class="header" :class="headerClasses">
            <div class="header-buttons-container" :class="{ 'header-buttons-container--undo': showUndo }">
                <filter-button v-if="authToken && !hideHeaderButtons" />
                <button @click.stop="visitLanding" class="logo">
                    <logo />
                </button>
                <cart-icon v-if="authToken && !hideHeaderButtons"></cart-icon>
            </div>
            <undo-pass-button @show-changed="(value) => showUndo = value" />
            <progress-bar v-if="showProgress" />
        </div>
    </Fragment>
</template>

<script>
    import Mixins from '../../mixins/mixins.js';
    import Logo from './logo.vue';
    import {mapGetters} from 'vuex';
    import CartIcon from './cart-icon.vue';
    import FilterButton from './filter-button.vue';
    import SubMenu from '../common/sub-menu.vue';
    import ProgressBar from './progress-bar.vue';
    import UndoPassButton from '../style-selection/undo-pass-button.vue';
    import NavMenu from './nav-menu.vue';
    import { Fragment } from 'vue-fragment';
    
    export default {
        components: {
            Logo,
            CartIcon,
            FilterButton,
            SubMenu,
            ProgressBar,
            UndoPassButton,
            NavMenu,
            Fragment,
        },
        data() {
            return {
                showUndo: false,
            };
        },
        computed: {
            currentProgress() {
                return (this.stepNumber + 1) / this.numberOfSteps * 100;
            },
            stepNumber() {
                return parseInt(this.$route.params.id) - 1;
            },
            routerMeta() {
                return this.$route.meta || {};
            },
            showProgress() {
                return !!this.routerMeta.showProgress;
            },
            hideHeaderButtons() {
                return !!this.routerMeta.hideHeaderButtons;
            },
            headerClasses() {
                return {
                    'is-main-menu-open': this.mainMenuOpen,
                    [this.headerStyle]: true,
                }
            },
            ...mapGetters({
                headerStyle: 'menu/headerStyle',
                authToken: 'auth/getAuthToken',
                numberOfSteps: 'onboarding/numberOfSteps',
                mainMenuOpen: 'menu/menuOpen'
            }),
        },
        methods:{
            visitLanding(){
                if(this.authToken){
                    this.$router.push({path: '/'});
                }
            },
        },
        mixins: [Mixins]
    }
</script>

<style lang="scss" scoped>
    .header {
        transition: all 0.4s ease;
        width: 100%;
        position: sticky;
        top: 0;
        left: 0;
        text-align: center;
        z-index: 100;
        background: #fff;
        &:not(.hidden) {
            .header-buttons-container {
                display: flex;
                justify-content: space-between;
                align-items: baseline;
                padding: 0 20px;
                position: relative;
                left: 0;
                transition: left 0.4s ease-out;
                &--undo {
                    left: -130px;
                }

                .logo {
                    margin: 0 auto;
                }
            }
            padding: 10px 0;
        }
        &.hidden {
            display:none;
        }
        &.is-main-menu-open {
            position: fixed;
            background: transparent;
        }
    }
</style>

<style lang="scss">
    .header {
        &.inverted {
            background: #000;
            .logo {
                path {
                    fill: #fff;
                }
            }
            .heart-icon{
                path {
                    fill: #fff;
                }
            }
            .cart-icon{
                path {
                    &.background {
                        fill: #fff;
                    }
                    &.outline {
                        fill: #000;
                    }
                }
            }
        }
        .count {
            text-align:center;
            color:#fff;
            font-size: 12px;
            width: 100%;
        }
        .logo {
            width: 119px;
            path {
                fill: #100d0c;
            }
        }
        path {
            transition: fill 0.4s ease;
        }
    }
    
</style>